import React, { useState } from 'react'
import Wrapper from './style'

const SchMenus = ({value, iconOnLeft, iconOnRight, children, amount}) => {
	const [childMenu, setChildMenu] = useState([])
	const [parentActive, setParentActive] = useState(false)

	const onClickParent = () => {
		setChildMenu(value);
		setParentActive(!parentActive);
	}

	return (
		<Wrapper>
			{value
				&&	<li
						className="list-parent"
						onClick={onClickParent}
					>
						<div className="left">
							<div className="icon-left">{iconOnLeft}</div>
							<div className="value">
								{value}
								&nbsp;
								{amount !== undefined
									&& <span>({amount})</span>
								}
							</div>
						</div>

						{children
							&& iconOnRight !== undefined
								&& <div className="icon-right">{iconOnRight}</div>
						}
					</li>
			}
			{parentActive
				&& childMenu === value
					&&	children
			}
		</Wrapper>
	)
}

export default SchMenus
